<template>
  <div>
    <new-help-list :titleText="title"></new-help-list>
  </div>
</template>

<script>
/* global PUBLIC_EMPTY_TITLE */

import NewHelpList from '@/components/NewHelpList.vue';

export default {
  name: 'Help2',
  components: {
    NewHelpList,
  },
  data() {
    return {
      title: PUBLIC_EMPTY_TITLE === '1' ? '意见反馈' : '帮助和反馈',
    };
  },
};
</script>
